// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"aaf51618","557":"c4dc51ec"}[chunkId] + ".chunk.css";
};